import SalesAccountForm from "../../components/AccountComponents/SaleAccountForm";

function NewSalesAccountPage() {
  return <SalesAccountForm method="post" title="Sales" />;
}

export default NewSalesAccountPage;